var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-header'),_vm._v(" "),(_vm.type === 'subject')?_c('teaching-subject',{ref:"teachingSubject"}):_vm._e(),_vm._v(" "),(_vm.type === 'thesis')?_c('teaching-thesis',{ref:"teachingThesis"}):_vm._e(),_vm._v(" "),_c('my-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b249d02","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/teaching.vue
// module id = null
// module chunks = 